import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getAsset(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}asset/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addAsset(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}asset/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddAssetType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/asset/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddAsset() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/asset/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByIdAsset(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}asset/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateAsset(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}asset/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
